/*=========================================================================================
  File Name: actions.js
==========================================================================================*/

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth ({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage ({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore ({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay ({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme ({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo ({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },

  updateSessionUser ({ commit }, payload) {
    commit('UPDATE_SESSION_USER', payload)
  },

  updateSessionUserAvatar ({ commit }, payload) {
    commit('UPDATE_SESSION_USER_AVATAR', payload)
  },

  updateSessionUserPermissions ({ commit }, payload) {
    commit('UPDATE_SESSION_USER_PERMISSIONS', payload)
  },

  updateUph ({ commit }, payload) {
    commit('UPDATE_UPH', payload)
  },

  updateUserSessionData ({ commit }, payload) {
    commit('UPDATE_SESSION_USER_DATA', payload)
  },

  resetSessionUserState ({ commit }, payload) {
    commit('RESET_SESSION_USER_STATE', payload)
  },

  setRedirectLocation ({ commit }, location) {
    commit('SET_REDIRECT_LOCATION', location)
  },
  setMfaRequirement ({ commit }, required) {
    commit('SET_MFA_REQUIREMENT', required)
  },
  updateMfaValidated ({ commit }, result) {
    commit('UPDATE_MFA_VALIDATION_RESULT', result)
  },
  setImpersonationState ({ commit }, payload) {
    commit('SET_IMPERSONATION_STATE', payload)
  }
}

export default actions
